import {
  Image,
  StyleSheet,
  Text,
  View,
  Dimensions,
  Animated,
  Easing,
  Platform,
} from "react-native";
import React from "react";
import { LinearGradient } from "expo-linear-gradient";
import FeedIcons from "../../../assets/Icons/FeedIcons";

const { width, height } = Dimensions.get("screen");

const SlideItem = ({ item, imageHeight }: { item: any; imageHeight?: any }) => {
  const translateYImage = new Animated.Value(40);

  Animated.timing(translateYImage, {
    toValue: 0,
    duration: 1000,
    useNativeDriver: true,
    easing: Easing.bounce,
  }).start();

  return (
    <View style={styles.container}>
      <View style={styles.ImageLayer}>
        <Animated.Image
          source={{ uri: item }}
          style={[
            styles.image,
            {
              height: imageHeight ? "80%" : "100%",
            },
          ]}
        />
        <LinearGradient
          colors={["rgba(0,0,0,0.5)", "transparent"]} // Adjust the colors and opacity as needed
          style={{
            position: "absolute", 
            left: 0,
            right: 0,
            top: 0,

            height: 200,
          }}
        />
        
        <LinearGradient
          colors={["rgba(0,0,0,0.5)", "transparent"]} // Adjust the colors and opacity as needed
          style={styles.gradient}
        />
      </View>
    </View>
  );
};

export default SlideItem;

const styles = StyleSheet.create({
  ImageLayer: {
    position: "relative",
    width,
    height,
  },
  container: {
    width,
    height,
    alignItems: "center",
    position: "relative",
  },
  image: {
    width: Platform.OS === "web" ? 390 : width,
    // height: "100%",
    // height:imageHeight
  },
  gradient: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: 200,
  },
});
